module.exports = function isString(arg) {
  return typeof arg === 'string';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stamp/is/string.js
// module id = 240
// module chunks = 0